import BambuserLiveShopping from './embed';
import { installReadyHandler } from './utils/readyHandler';
import { installHashAddToCartHandler } from './utils/hashAddToCartHandler';
import { customTagsHandler } from './utils/customTagsHandler';
import { embedTrackingHandler } from './utils/embedTracking';
import { installWebComponents } from './webComponents';
import { installDebugPanel } from './utils/debugPanel';
import PageFacade from './utils/pageFacade';

try {
  installDebugPanel();
} catch (err) {
  console.log('Error installing debug panel', err);
}

try {
  installReadyHandler(window, BambuserLiveShopping);
} catch (err) {
  console.log('Error installing ready handler', err);
}

try {
  embedTrackingHandler(window, document, BambuserLiveShopping);
} catch (err) {
  console.log('Error installing embed loaded tracking', err);
}

try {
  customTagsHandler(window, document, BambuserLiveShopping);
} catch (err) {
  console.log('Error installing custom tags handler', err);
}

installHashAddToCartHandler(window, BambuserLiveShopping).catch((err) => {
  console.log('Error installing hash add to cart handler', err);
});

try {
  installWebComponents();
} catch (err) {
  console.log('Error installing web components', err);
}

BambuserLiveShopping.PageFacade = PageFacade; // expose PageFacade class for dev/debug usage
